/* dashboard-rediseno, segunda vuelta (D1 y D9 de la medicion): EL ANCHO DE TEXTO DE UNA TARJETA.

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   Lo que se acomoda cuando una tarjeta es angosta se decide por el ancho REAL de su texto (la caja
   de contenido de la tarjeta, sin el relleno), no por un corte de la ventana: la misma ventana da
   tarjetas de 254 px en una columna y de 224 en una parte dentro de un padre abierto.

   La pieza no vuelve a pintar React: un `ResizeObserver` pone o quita dos marcas en la tarjeta, y
   las clases de adentro las leen con la variante de grupo de la tarjeta:
     - `data-angosta`: menos de 228 px de texto. El boton chico "Retry" se queda con su icono
       (el texto pasa al lector de pantalla), como pide el documento para A10.
     - `data-estrecha`: menos de 264 px de texto. "View topics" deja su icono, el pie aprieta su
       hueco y la frase de la tarjeta bloqueada baja a 12 px: asi "Readiness" y "Locked. Upgrade to
       unlock." se leen enteros (D9).
   Sin `ResizeObserver` (jsdom) no se pone ninguna marca: la tarjeta queda como la ancha.

   Una tarjeta escondida (la gemela que no se ve) mide 0: lleva las dos marcas y no importa. */
import { useLayoutEffect } from 'react';

export const ANCHO_ANGOSTA = 228;
export const ANCHO_ESTRECHA = 264;

export function marcarAncho(el, ancho) {
  if (!el) return;
  const poner = (nombre, si) => {
    if (si) el.setAttribute(nombre, '');
    else el.removeAttribute(nombre);
  };
  poner('data-angosta', ancho < ANCHO_ANGOSTA);
  poner('data-estrecha', ancho < ANCHO_ESTRECHA);
}

export function useAnchoDeTexto(ref) {
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el || typeof window === 'undefined' || typeof window.ResizeObserver !== 'function') return undefined;
    const observador = new window.ResizeObserver((entradas) => {
      const e = entradas[entradas.length - 1];
      if (e && e.contentRect) marcarAncho(el, e.contentRect.width);
    });
    observador.observe(el);
    return () => observador.disconnect();
  }, [ref]);
}
